require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-miguel-yee-bacaoco.json") })
        }
      }, "path---member-miguel-yee-bacaoco");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-miguel-yee-bacaoco!./.cache/json/member-miguel-yee-bacaoco.json
// module id = 404
// module chunks = 231608221292675